import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DriveLookupService } from 'src/app/my-account/test-papers/drive-lookup.service';
import { DigitalResource } from '../digital-downloads/digital-downloads.component';
import { DigitalDownloadService } from 'src/app/common-myaccount-service/digital-download.service';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';


export interface DriveProductMeta {
  fileName: string;
  slug?: string;
  title: string;
  description: string;
  category: string;
  level: string;
  icon: string;
  colorKey: string;
  price: number;
  salePrice?: number;
  downloads: number;
}

@Component({
  selector: 'app-digital-download-details',
  imports: [
    RouterModule,
    CommonModule,
    FormsModule
  ],
  templateUrl: './digital-download-details.component.html',
  styleUrl: './digital-download-details.component.css',
})
export class DigitalDownloadDetailsComponent {


downloadsFolderId = '18elBWCvKM1tApaMB-MqoEqZ-qYh0wBmz';
apiKey = 'AIzaSyDR484mbUxUuZfrBH2DkmuUrS4oFXhNT9w';


resources: DigitalResource[] = [];
resource!: DigitalResource;
relatedResources: DigitalResource[] = [];
loading = true;

  constructor(
      private drive: DriveLookupService,
      private route: ActivatedRoute,
      private digitalDownloadService: DigitalDownloadService
    ) {}

showModal = false;
  activeTab: 'purchase' | 'existing' = 'purchase';
  selectedResource: DigitalResource | null = null;

  isProcessingPayment = false;
  paymentCompleted = false;
  downloadUrl = '';
  orderId = '';
  paymentId = '';

  lookupEmail = '';
  purchaseFound = false;
  purchaseChecked = false;



  formData = {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    consent: false,
  };

  formErrors: Record<string, string> = {
    firstName: '',
    lastName: '',
    email: '',
  };




  ngOnInit(): void {

    this.route.paramMap.subscribe(params => {

        const slug = params.get('slug') || '';

        this.loadProductsFromDrive(slug);

    });

}

loadSelectedProduct(
    slug: string
): void {

    const product =
        this.resources.find(
            x => x.slug === slug
        );

    if (!product) {
        return;
    }

    this.resource = product;

    this.selectedResource = product;

    this.relatedResources =
        this.resources
            .filter(x =>
                x.slug !== slug &&
                x.category === product.category
            )
            .slice(0,4);

    this.loading = false;

}

generateSlug(title: string): string {

    return title
        .toLowerCase()
        .replace(/\+/g,'plus')
        .replace(/&/g,'and')
        .replace(/[^a-z0-9]+/g,'-')
        .replace(/^-+|-+$/g,'');

}


loadProductsFromDrive(
    slug: string
): void {

    this.drive
        .listChildFolders(
            this.downloadsFolderId,
            this.apiKey,
            {
                orderBy: 'name'
            }
        )
        .subscribe({

            next: folders => {

                folders.forEach(folder => {

                    this.loadCategoryProducts(
                        folder,
                        slug
                    );

                });

            }

        });

}


loadCategoryProducts(
    categoryFolder: any,
    slug: string,

  ): void {

    this.drive

      .findFileByExactName(

        categoryFolder.id,

        'products.json',

        this.apiKey

      )

      .subscribe({

        next: (jsonFile: any) => {

          if (!jsonFile) {

            console.warn(

              'products.json missing in',

              categoryFolder.name

            );

            return;

          }

          this.drive

            .loadJsonFile(

              jsonFile.id,

              this.apiKey

            )

            .subscribe({

              next: (

                productMetaList: DriveProductMeta[]

              ) => {

                this.drive

                  .listFilesInFolder(

                    categoryFolder.id,

                    this.apiKey

                  )

                  .subscribe({

                    next: (files: any[]) => {

                      this.mapProducts(
                        productMetaList,
                        files,
                        slug,

                      );

                    },

                    error: (err) => {

                      console.error(

                        'Failed loading files',

                        err

                      );

                    }

                  });

              },

              error: (err) => {

                console.error(

                  'Failed loading products.json',

                  err

                );

              }

            });

        },

        error: (err) => {

          console.error(

            'Failed locating products.json',

            err

          );

        }

      });

  }



    mapProducts(
      productMetaList: DriveProductMeta[],
      files: any[],
      slug: string
  
    ): void {
  
      productMetaList.forEach(meta => {
  
        const file = files.find(f => {
  
          return (
  
            f.name &&
  
            f.name
  
              .toString()
  
              .trim()
  
              .toLowerCase() ===
  
            meta.fileName
  
              .toString()
  
              .trim()
  
              .toLowerCase()
  
          );
  
        });
  
        if (!file) {
  
          console.warn(
  
            'Matching file not found:',
  
            meta.fileName
  
          );
  
          return;
  
        }
  
        const resource: DigitalResource = {
  
    id: this.resources.length + 1,
  
    slug:
      meta.slug ||
      this.generateSlug(meta.title),
  
    title: meta.title,
  
    description: meta.description,
  
    category: meta.category,
  
    level: meta.level,
  
    icon: meta.icon,
  
    colorKey: meta.colorKey,
  
    fileType: this.getFileType(meta.fileName),
  
    fileSize: this.formatBytes(Number(file.size || 0)),
  
    fileName: meta.fileName,
  
    fileId: file.id,
  
    fileUrl: this.drive.buildDownloadUrl(file.id),
  
    price: meta.price,
  
    salePrice: meta.salePrice,
  
    downloads: meta.downloads || 0
  
  };
  
        this.resources.push(resource);
  
      });

      this.loadSelectedProduct(slug);
  
    }



   openPurchaseModal(
    resource: DigitalResource
  ): void {
    this.selectedResource = resource;
    this.activeTab = 'purchase';
    this.showModal = true;
    this.paymentCompleted = false;
    this.purchaseFound = false;
    this.purchaseChecked = false;
    this.lookupEmail = '';
    this.downloadUrl = '';
    this.resetForm();
    document.body.style.overflow =
      'hidden';
  }


  closeModal(): void {
    this.showModal = false;
    this.selectedResource = null;
    document.body.style.overflow = '';
  }


  resetForm(): void {

    this.formData = {
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      consent: false,
    };

    this.formErrors = {
      firstName: '',
      lastName: '',
      email: '',
    };

  }



   clearError(field: string): void {

    this.formErrors[field] = '';

  }

  validateForm(): boolean {

    let valid = true;

    this.formErrors = {

      firstName: '',

      lastName: '',

      email: '',

    };

    if (!this.formData.firstName.trim()) {

      this.formErrors.firstName =
        'First name is required';

      valid = false;

    }

    if (!this.formData.lastName.trim()) {

      this.formErrors.lastName =
        'Last name is required';

      valid = false;

    }

    if (!this.formData.email.trim()) {

      this.formErrors.email =
        'Email address is required';

      valid = false;

    } else if (
      !this.isValidEmail(
        this.formData.email
      )
    ) {

      this.formErrors.email =
        'Please enter a valid email address';

      valid = false;

    }

    return valid;

  }

  isValidEmail(
    email: string
  ): boolean {

    const re =
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    return re.test(email);

  }

  createOrder(): void {

    if (!this.validateForm()) {
      return;
    }

    if (!this.selectedResource) {
      return;
    }

    this.isProcessingPayment = true;

    const payload = {

  first_name:
    this.formData.firstName,

  last_name:
    this.formData.lastName,

  email:
    this.formData.email,

  phone:
    this.formData.phone,

  consent:
    this.formData.consent ? 1 : 0,

  resource_title:
    this.selectedResource.title,

  resource_category:
    this.selectedResource.category,

  file_name:
    this.selectedResource.fileName,

  file_id:
    this.selectedResource.fileId,

  download_url:
    this.selectedResource.fileUrl,

  amount:
    this.selectedResource.salePrice ||
    this.selectedResource.price

};

    console.log(
      'Create Order Payload',
      payload
    );

    /**
     * ===================================================
     * ACTUAL IMPLEMENTATION LATER
     * ===================================================
     */

    this.digitalDownloadService
  .createOrder(payload)
  .subscribe({

    next: (response) => {

      this.isProcessingPayment = false;

      if (
        response?.data?.payment_url
      ) {

        console.log('Payment URL:', response.data.payment_url);

        // window.location.href =
        //   response.data.payment_url;

      }

    },

    error: (error) => {

      this.isProcessingPayment = false;

      console.error(error);

      alert(
        'Unable to create payment order.'
      );

    }

  });

  }


  paymentSuccess(
    downloadUrl: string
  ): void {

    this.downloadUrl =
      downloadUrl;

    this.paymentCompleted =
      true;

  }


  checkPurchase(): void {

    if (
      !this.lookupEmail ||
      !this.selectedResource
    ) {

      return;

    }

    this.purchaseChecked = false;

    this.purchaseFound = false;

    /**
     * ============================================
     * ACTUAL API IMPLEMENTATION
     * ============================================
     */

    
    this.digitalDownloadService
  .checkPurchase({

    email:
      this.lookupEmail,

    file_name:
      this.selectedResource.fileName

  })
      .subscribe({

        next: (response) => {

          this.purchaseChecked =
            true;

          this.purchaseFound =
            response.purchased;

          if (
            response.purchased
          ) {

            this.downloadUrl =
              response.download_url;

          }

        },

        error: () => {

          this.purchaseChecked =
            true;

        }

      });
    

    /**
     * TEMP DEMO
     */

    setTimeout(() => {

      this.purchaseChecked =
        true;

      this.purchaseFound = true;

      this.downloadUrl =
        this.selectedResource!.fileUrl;

    }, 800);

  }


  trackDownload(): void {

  if (!this.orderId) {
    return;
  }

  this.digitalDownloadService
    .trackDownload({

      order_id: this.orderId

    })
    .subscribe();
this.closeModal();
}

 getFileType(
    fileName: string
  ): string {

    if (!fileName) {

      return 'FILE';

    }

    const parts =
      fileName.split('.');

    if (
      parts.length < 2
    ) {

      return 'FILE';

    }

    return (
      parts
        .pop()
        ?.toUpperCase() ||
      'FILE'
    );

  }

  formatBytes(
    bytes: number
  ): string {

    if (
      !bytes ||
      bytes === 0
    ) {

      return '0 Bytes';

    }

    const k = 1024;

    const sizes = [
      'Bytes',
      'KB',
      'MB',
      'GB'
    ];

    const i = Math.floor(
      Math.log(bytes) /
      Math.log(k)
    );

    return (
      parseFloat(
        (
          bytes /
          Math.pow(k, i)
        ).toFixed(1)
      ) +
      ' ' +
      sizes[i]
    );

  }

}
